import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'

const ProjectConfigurationSchemes = () => {
    const table = useRef(null)
    const urlGetData = '/v0/project_configuration_schemes'
    const localStorageOrderKey = 'tblProjectConfigurationSchemesOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' }
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
        </tr>
    )
    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/project_configuration_schemes/${row.id}`),
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>Configuration Schemes</h2>

                            <div className="pre-table-buttons">
                                <Link type="button" className="btn btn-mr btn-primary" to="/cadm/project_configuration_schemes/new">New Configuration Scheme</Link>
                                <Link to="/cadm/typecode_group_mappings">Type-Code Maps</Link>
                                <Link to="/cadm/reference_structures">Reference Structures</Link>
                            </div>
                            
                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                <strong>Configuration schemes</strong> define the configuration management rules for each opportunity, project and product in your portfolio.<br/>
                                This includes which <strong>reference structures</strong> and which <strong>type-code maps</strong> to use for <strong>documents</strong> and <strong>records</strong>.<br/>
                                Each configuration scheme may be applied <strong>one or many times</strong> across your portfolio.
                            </div>

                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default ProjectConfigurationSchemes;
